

    <svg:text class="io-type" [ngClass]="{'activated-io-type': activate}" [attr.x]="textX" [attr.y]="textY"
              font-size="14"
              [attr.text-anchor]="anchor">
      <svg:tspan font-weight="bold">{{ name }}</svg:tspan>
      <svg:tspan>:</svg:tspan>
      <svg:tspan>{{ typeText }}</svg:tspan>
    </svg:text>

    <svg:circle *ngIf="initialized" xmlns:svg="http://www.w3.org/1999/html" [attr.cx]="specification.at.x"
                [attr.cy]="specification.at.y" fill="#000" stroke="#00F" stroke-width="1" [ngClass]="{'anchor-point': editable}"
                (mousedown)="onMouseDown($event)" [class.highlighted-point]="highlight"
                [attr.r]="radius"/>
  


// WEBPACK FOOTER //
// ./src/library/graph/vertex/interaction-point/workflow-graph-vertex-outlet-point.component.ts.WorkflowGraphVertexOutletPointComponent.html